import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @jsx jsx */
import React, { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { N0, N50A, N60A, N900 } from '@atlaskit/theme/colors';
import { layers } from '@atlaskit/theme/constants';
var CSS_THEME_BACKGROUND = '--theme-background';
var CSS_THEME_COLOR = '--theme-color';
var CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
var containerStyles = css({
  boxSizing: 'content-box',
  maxWidth: "".concat(8 * 56, "px"),
  maxHeight: "".concat(8 * 56, "px"),
  padding: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-300, 24px)"),
  zIndex: layers.dialog(),
  background: "var(".concat(CSS_THEME_BACKGROUND, ")"),
  borderRadius: "var(--ds-border-radius, 3px)",
  boxShadow: "var(".concat(CSS_THEME_BOX_SHADOW, ")"),
  color: "var(".concat(CSS_THEME_COLOR, ")"),
  '&:focus': {
    outline: 'none'
  }
});
/**
 * __Container__
 *
 * A container is used as a styled wrapper around the contents of an inline dialog.
 * Note that the styles here are merged with the style prop that comes from the popper.js library.
 *
 */
export var Container = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _objectSpread2;
  var children = _ref.children,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    style = _ref.style,
    testId = _ref.testId;
  return (
    // Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("div", {
      css: containerStyles,
      "data-testid": testId,
      onBlur: onBlur,
      onClick: onClick,
      onFocus: onFocus,
      ref: ref
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,
      style: _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, CSS_THEME_BACKGROUND, "var(--ds-surface-overlay, ".concat(N0, ")")), _defineProperty(_objectSpread2, CSS_THEME_COLOR, "var(--ds-text, ".concat(N900, ")")), _defineProperty(_objectSpread2, CSS_THEME_BOX_SHADOW, "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")")), _objectSpread2), style)
    }, children)
  );
});